import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontSize, YodaSpacing } from 'yoda-ui/yodaTheme';

export const heading1Style: SxProps<Theme> = {
  marginBottom: YodaSpacing.large,
  fontSize: YodaFontSize.xLargePlus,
  fontWeight: '600',
  color: YodaColors.textPrimary,
};

export const heading2Style: SxProps<Theme> = {
  marginBottom: YodaSpacing.medium,
  fontSize: YodaFontSize.medium,
  fontWeight: '600',
  color: YodaColors.textPrimary,
};

export const heading3Style: SxProps<Theme> = {
  marginBottom: YodaSpacing.small,
  fontSize: YodaFontSize.small,
  color: YodaColors.gray5,
};
